import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { TownFailure, TownRequest, TownSuccess } from './actions';
import { TownService } from './service';

@Injectable()
export class TownEffects {
  private readonly actions$ = inject(Actions);
  private readonly townService = inject(TownService);

  town$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TownRequest),
      switchMap(({ parameters }) =>
        this.townService.town(parameters).pipe(
          map(data => TownSuccess({ data })),
          catchError(error => of(TownFailure({ error })))
        )
      )
    )
  );

}
